export default "__VITE_ASSET__fb3511bd__"